// extracted by mini-css-extract-plugin
export default {"container":"modal_container__yszCx","button":"modal_button__doA-T","text":"modal_text__Q1-GI","loaderAndText":"modal_loaderAndText__WXuxH","loader":"modal_loader__tD1Tr"};